import { useMsal } from "@azure/msal-react";

export const UserButton = () => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const handleLogOutPopup = () => {
        instance
            .logoutPopup({
                mainWindowRedirectUri: "/", // redirects the top level app after logout
                account: instance.getActiveAccount()
            })
            .catch(error => console.log(error));
    };
    const userText = `${activeAccount?.name}`;

    return (
        <div className="flyout-container inline-block relative">
            <div className="flyout-menu hidden absolute bottom-full left-[-.5rem] z-[100] md:w-[228px] w-[288px] transition-all ease-linear duration-300 bg-sstl-white shadow-lg-up border-b-[3px] border-[#1A86A6]">
                <div className="py-2 px-5 hover:bg-sstl-dark hover:text-sstl-white ease-linear transition-all duration-300">
                    <div className="flex flex-col">
                        <div className="py-2 font-normal leading-7">
                            <a
                                className="gap-1 w-fit ease-linear transition-transform duration-300 flex cursor-pointer text-center items-center text-lg whitespace-nowrap"
                                onClick={handleLogOutPopup}
                            >
                                <span className="text-[0.875rem]">
                                    <span className="pb-[3px]">Log out</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flyout-button flex justify-start cursor-pointer py-2 w-auto whitespace-nowrap items-center transition-all ease-linear duration-300">
                <a className="text-sm leading-6 font-bold">{userText}</a>
                <div className="px-3">
                    <svg
                        stroke="currentColor"
                        className="flyout-chevron stroke-sstl-yellow fill-sstl-yellow transition-all ease-in-out duration-300 rotate-180"
                        height="1em"
                        width="1em"
                        x="0px"
                        y="0px"
                        viewBox="0 0 86 106"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g>
                            <polygon className="path" points="85.1,78.1 85.2,27.4 41.9,0.1"></polygon>
                            <polygon className="path" points="41.8,51.5 -0.1,77.4 41.9,106.3 85.1,78.1"></polygon>
                            <polygon className="path" points="-0.1,77.4 0,26.3 41.9,0.1"></polygon>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    );
};
